import { z } from 'zod';
import validations from 'utils/validations';

export const validationSchema = z.object({
  code: validations.requiredString('Required'),
  description: validations.requiredString('Required'),
  kind: validations.requiredString('Required'),
  number: validations.requiredString('Required'),
});

const numberField = (invalidMsg: string, requiredMsg: string) => z.preprocess(
  (value) => {
    if (typeof value === 'string') {
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? NaN : parsed;
    }
    return value;
  },
  z.number({ invalid_type_error: invalidMsg, required_error: requiredMsg }),
);

export const validationSchemaCharges = z.object({
  charges: z.array(z.object({
    description: validations.requiredString('El campo descripción es requerido'),
    by_others: numberField('El campo by_others debe ser un número', 'El campo by_others es requerido'),
    buyer_at: numberField('El campo buyer_at debe ser un número', 'El campo buyer_at es requerido'),
    buyer_before: numberField('El campo buyer_before debe ser un número', 'El campo buyer_before es requerido'),
    seller_at: numberField('El campo seller_at debe ser un número', 'El campo seller_at es requerido'),
    seller_before: numberField('El campo seller_before debe ser un número', 'El campo seller_before es requerido'),
    tax: numberField('El campo tax debe ser un número', 'El campo tax es requerido'),
    per_month: numberField('El campo tax debe ser un número', 'El campo tax es requerido'),
    months: numberField('El campo tax debe ser un número', 'El campo tax es requerido'),
  }).passthrough()),
});
